// extracted by mini-css-extract-plugin
module.exports = {"chip":"NoteChip_chip__2zsSz","chipIcon":"NoteChip_chipIcon__2Bjgf","chipText":"NoteChip_chipText__yeTvD"};